<template>

    <div class="nav-scroller  table-responsive mt-4" style="height:400px;">
        <!-- <CambialiListTableSelectColumn/> -->
        <table id="dtHorizontalVerticalExample " class="table table-striped table-bordered table-sm bg-light"
               cellspacing="0"
               width="100%">

            <thead class="">
            <tr>
                <th scope="col">Codice</th>
                <th scope="col">Nome</th>
                <th scope="col">Num. Rate</th>
                <th scope="col">Totale</th>
                <th scope="col">Prima Scad.</th>
                <th scope="col">Ultima Scad.</th><!-- <th scope="col"></th> -->
            </tr>
            </thead>
            <tbody>

            <tr v-if="isLoading">
                <td colspan="6">
                    <p class="mt-2">Caricamento in corso...</p>
                </td>
            </tr>

            <tr v-if="isError && !isLoading">
                <td colspan="6">
                    <p class="mt-2">Errore caricamento dei dati, riprova.</p>
                </td>
            </tr>

            <tr v-if="!isLoading && !isError && amortizations.length==0">
                <td colspan="6">
                    <p class="mt-2">Non sono presenti pratiche di cambiali.</p>
                    <p>Creane uno
                        <router-link to="/amortizations/create" tag="a">Nuovo</router-link>
                        .
                    </p>
                </td>
            </tr>
            <tr v-for="amortization in amortizations">  <!-- v-bind:key = amortization.id -->
                <td>{{amortization.code}}</td>
                <td>{{amortization.debtor_last_name}} {{amortization.debtor_first_name}}</td>
                <td>{{amortization.rates}}</td>
                <td>{{formatPrice(amortization.total_amount)}} €</td>
                <td>{{amortization.first_expire_date | moment('DD-MM-YYYY')}}</td>
                <td>{{amortization.last_expire_date | moment('DD-MM-YYYY')}}</td>
                <td>
                    <router-link :to="{ name: 'modify_amortization', params:{id:amortization.id} }"
                                 tag="button">
                        Dettaglio
                    </router-link>
                    <button @click="cloneAmortization(amortization.id)" style="margin-left:10px;">
                        Duplica
                    </button>
                    <button @click="deleteAmortization(amortization.id)" style="margin-left:10px;">
                        Elimina
                    </button>


                </td>

            </tr>
            </tbody>
        </table>

        <!-- <nav class="nav d-flex justify-content-between">

          <div class="form-group">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="gridCheck">
              <label class="form-check-label" for="gridCheck">Luogo Emissione</label>
              <span style="margin-right: 26px;">   </span>
              <input class="form-check-input" type="checkbox" id="gridCheck">
              <label class="form-check-label" for="gridCheck">Data emissione</label>
              <span style="margin-right: 26px;">   </span>
              <input class="form-check-input" type="checkbox" id="gridCheck">
              <label class="form-check-label" for="gridCheck">Importo in cifre</label>
              <span style="margin-right: 26px;">   </span>
              <input class="form-check-input" type="checkbox" id="gridCheck">
              <label class="form-check-label" for="gridCheck">Scadenza</label>
              <span style="margin-right: 26px;">   </span>
              <input class="form-check-input" type="checkbox" id="gridCheck">
              <label class="form-check-label" for="gridCheck">Pag...</label>
              <span style="margin-right: 26px;">   </span>
              <input class="form-check-input" type="checkbox" id="gridCheck">
              <label class="form-check-label" for="gridCheck">Beneficiario</label>
              <span style="margin-right: 26px;">   </span>
              <input class="form-check-input" type="checkbox" id="gridCheck">
              <label class="form-check-label" for="gridCheck">Importo in Lettere</label>
              <span style="margin-right: 26px;">   </span>
              <input class="form-check-input" type="checkbox" id="gridCheck">
              <label class="form-check-label" for="gridCheck">Domiciliazione Nome</label>
              <span style="margin-right: 26px;">   </span>
            </div>
          </div>

        </nav> -->
    </div>
</template>

<script>

    import axios from 'axios'

    export default {
        name: 'CambialiTable',
        data: function () {
            return {
                isError: false,
                isLoading: true,
                amortizations: [],
                basePathApi: process.env.VUE_APP_API_BASE_URL,
            }
        },
        components: {

            // CambialiListTableSelectColumn: CambialiListTableSelectColumn
        },
        mounted: function () {
            this.getAmortizations()
        },
        methods: {
            formatPrice(value) {
                let val = (value / 1).toFixed(2).replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },
            showPdf: function (id, type) {
                axios({
                    url: process.env.VUE_APP_API_BASE_URL + '/api/v1/amortization/' + id + '/pdf?type=' + type,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    //Create a Blob from the PDF Stream
                    const file = new Blob(
                        [response.data],
                        {type: 'application/pdf'})//Build a URL from the file
                    const fileURL = URL.createObjectURL(file)//Open the URL on new Window
                    window.open(fileURL, '_blank')
                })

            },
            getAmortizations: function () {
                var $vm = this
                $vm.isLoading = true
                $vm.isError = false
                axios.get(process.env.VUE_APP_API_BASE_URL + '/api/v1/user/' + $vm.loggedUser.id + '/amortizations?filter=CONFIRMED')
                    .then(function (response) {
                        $vm.amortizations = response.data
                        $vm.isLoading = false
                    })
                    .catch(function (e) {
                        $vm.isLoading = false
                        $vm.isError = true
                    })
            },
            cloneAmortization: function (id) {
                var $vm = this
// Trigger a confirmation dialog
                this.$dialog
                    .confirm('Sei sicuro di voler duplicare l\'ammortamento?', {cancelText: 'Annulla', okText: 'Conferma'})
                    .then(function (dialog) {
                        axios.post(process.env.VUE_APP_API_BASE_URL + '/api/v1/amortization/' + id + '/clone')
                            .then(function (response) {
                                $vm.$router.push({ name: 'modify_amortization', params: { id: response.data.id } })
                            })
                    })
                    .catch(function () {
                    })

            },
            deleteAmortization: function (id) {
                var $vm = this
// Trigger a confirmation dialog
                this.$dialog
                    .confirm('Sei sicuro di voler cancellare?', {cancelText: 'Annulla', okText: 'Conferma'})
                    .then(function (dialog) {
                        axios.delete(process.env.VUE_APP_API_BASE_URL + '/api/v1/amortization/' + id + '?force_delete=true')
                            .then(function (response) {
                                $vm.getAmortizations()
                            })
                    })
                    .catch(function () {
                    })

            }
        }
    }

</script>

<style>


    .nav-scroller {
        position: relative;
        z-index: 2;
        height: 2.75rem;
        overflow-y: auto !important;
    }

    .nav-scroller .nav {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: nowrap;
        flex-wrap: nowrap;
        padding-bottom: 1rem;
        margin-top: -1px;
        overflow-x: auto;
        text-align: center;
        white-space: nowrap;
        -webkit-overflow-scrolling: touch;
    }

    .nav-scroller .nav-link {
        padding-top: .75rem;
        padding-bottom: .75rem;
        font-size: .875rem;
    }

    .dtHorizontalVerticalExampleWrapper {
        max-width: 600px;
        margin: 0 auto;
    }

    #dtHorizontalVerticalExample th, td {
        white-space: nowrap;
    }

    table.dataTable thead .sorting:after,
    table.dataTable thead .sorting:before,
    table.dataTable thead .sorting_asc:after,
    table.dataTable thead .sorting_asc:before,
    table.dataTable thead .sorting_asc_disabled:after,
    table.dataTable thead .sorting_asc_disabled:before,
    table.dataTable thead .sorting_desc:after,
    table.dataTable thead .sorting_desc:before,
    table.dataTable thead .sorting_desc_disabled:after,
    table.dataTable thead .sorting_desc_disabled:before {
        bottom: .5em;
    }


    .textOverflowHidden {
        display: inline-block;
        width: 230px;
        white-space: nowrap;
        overflow: hidden !important;
        text-overflow: ellipsis;
    }
</style>
